import React from 'react';
import { DropdownList } from '../../layouts/main/Main';

interface DropdownProps {
  label?: string;
  title?: string;
  classes?: string;
  children?: React.ReactNode;
  icon?: string;
  isListOpen?: DropdownList | undefined;
  setIsListOpen?: (DropdownList: { [p: string]: boolean }) => void;
  selectedTab?: string | undefined;
}

const Dropdown = ({
  label,
  title,
  classes = '',
  children,
  icon,
  isListOpen,
  setIsListOpen,
  selectedTab,
}: DropdownProps) => {
  const handleBlur = (e: React.FocusEvent) => {
    const currentTarget = e.currentTarget;

    setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        setIsListOpen &&
          selectedTab &&
          setIsListOpen({ ...isListOpen, [selectedTab]: false });
      }
    }, 0);
  };

  return (
    <div className={'dropdown ' + classes} onBlur={handleBlur} tabIndex={1}>
      <div
        className='dropdown-header'
        title={title}
        onClick={() =>
          setIsListOpen &&
          selectedTab &&
          setIsListOpen({ ...isListOpen, [selectedTab]: true })
        }
      >
        <label>
          {label}
          <i className={icon} />
        </label>
      </div>
      <div
        className={`dropdown-content ${
          selectedTab && isListOpen !== undefined && isListOpen[selectedTab]
            ? 'list-open'
            : ''
        }`}
      >
        <ul>
          {React.Children.map(children, (child, index) => (
            <li className='noSelect' key={index}>
              {child}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Dropdown;
